export function strip(num, precision = 12) {
  return +parseFloat(num.toPrecision(precision))
}

// export function formatNum (num) {
//   // 0也要能留下來，所以只擋undefined
//   if (num !== undefined) {
//     num = Math.round(num * 100) / 100 // 四捨五入取小數點第二位
//     const integer = num.toString().split('.')[0]
//     const decimal = num.toString().split('.')[1] ? `.${num.toString().split('.')[1]}` : ''
//     return `${integer.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}${decimal}`
//   } else {
//     return ''
//   }
// }

export function formatNum(num) {
  if (num === undefined || num === null) return ''

  // 检查数值大小，调整显示格式
  if (Math.abs(num) >= 1000000000) {
    // 十亿位数以上
    num = Math.round(num / 10000000) / 100 // 四舍五入到百万位
    const rounded = Math.round(num * 100) / 100
    return rounded % 1 === 0 ? `${Math.round(rounded)}B` : `${rounded}B`
  } else if (Math.abs(num) >= 1000000) {
    // 百万位数以上
    num = Math.round(num / 10000) / 100 // 四舍五入到十万位
    const rounded = Math.round(num * 100) / 100
    return rounded % 1 === 0 ? `${Math.round(rounded)}M` : `${rounded}M`
  } else if (Math.abs(num) >= 100000) {
    // 十万位数以上
    num = Math.round(num / 10) / 100 // 四舍五入到百位
    const rounded = Math.round(num * 100) / 100
    return rounded % 1 === 0 ? `${Math.round(rounded)}K` : `${rounded}K`
  } else if (Math.abs(num) >= 10000) {
    // 万位数以上
    num = Math.round(num * 10) / 10 // 四舍五入到小数点后一位
    return num % 1 === 0
      ? num.toLocaleString('en-US', { minimumFractionDigits: 0 })
      : num.toLocaleString('en-US', {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        })
  } else if (Math.abs(num) >= 1000) {
    // 千位数以上
    return num % 1 === 0
      ? num.toLocaleString('en-US', { minimumFractionDigits: 0 })
      : num.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
  } else {
    // 千位数以下，保留最多两位小数
    return num % 1 === 0 ? num.toString() : num.toFixed(2)
  }
}

// export function formatNum(num) {
//   if (num === undefined) return '';

//   // 四舍五入到第二位小数
//   num = Math.round(num * 100) / 100;

//   // 检查数值大小，调整显示格式
//   if (Math.abs(num) >= 1000000) {
//     // 百万位数以上
//     num = Math.round(num / 100000) / 10; // 四舍五入到十万位
//     const rounded = Math.round(num);
//     return rounded % 10 === 0 ? `${rounded}M` : `${num}M`;
//   } else if (Math.abs(num) >= 10000) {
//     // 萬位数以上
//     num = Math.round(num / 100) / 10; // 四舍五入到百位
//     const rounded = Math.round(num);
//     return rounded % 10 === 0 ? `${rounded}K` : `${num}K`;
//   } else {
//     // 千位数以下
//     const integerPart = Math.floor(num);
//     const decimalPart = Math.round((num - integerPart) * 100) / 100;
//     const decimalString = decimalPart > 0 ? decimalPart.toFixed(2).slice(1) : '';
//     return `${integerPart}${decimalString}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//   }
// }

/**
 * 將Number指定位數四捨五入後改為用千分位顯示之字串
 * dotValue為欲保留的小數點點位，為10的N次方 默認為100
 * 用法:
 * 填入1000即保留小數點後三位。第四位做四捨五入
 */
export function numberPackage(value, dotValue) {
  let setDot = 100
  if (dotValue !== undefined) {
    setDot = dotValue
  }
  const round = Math.round(value * setDot) / setDot
  const integer = round.toString().split('.')[0]
  const decimal = round.toString().split('.')[1]
    ? `.${round.toString().split('.')[1]}`
    : ''
  return `${integer.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}${decimal}`
  // return String(round).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// 四捨五入到第二位
export function round(num, decimal = 2) {
  const decimals = Math.pow(10, decimal)
  return Math.round(num * decimals) / decimals
}

// 無條件捨去(預設到第二位)
export function floor(num, decimal = 2) {
  const decimals = Math.pow(10, decimal)
  return Math.floor(num * decimals) / decimals
}

// 數字輸入框顯示帶千位符，可控制小數點位數
export function formatter(value, decimals) {
  if (value == null || isNaN(value)) return '0'

  const formattedValue =
    decimals != null
      ? Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)
      : value

  return `${formattedValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/**
 * 動態對數值進行 scale 處理
 * @param {number} name - 名稱 (SYS | DIAMOND | EXP | CHIP)
 * @param {number} value - 數值
 * @returns {number} - 處理後的數值
 */
export function dynamicRound(name, value) {
  const currencyList = JSON.parse(sessionStorage.getItem('currencyList'))
  const currencyItem = currencyList.find((item) => item.name === name)
  const factor = Math.pow(10, currencyItem.scale)

  // 捨入模式
  switch (currencyItem.roundingMode) {
    case 0: // 無條件進位
      return Math.ceil(value * factor) / factor
    case 1: // 無條件捨去
      return Math.floor(value * factor) / factor
    case 4: // 四捨五入
      return Math.round(value * factor) / factor
    default:
      throw new Error('Invalid rounding mode')
  }
}
